/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

import { useToast } from "@chakra-ui/react";
import { useCallback } from "react";
import { getErrorMessage } from "utils/errorHandler";

/**
 * useErrorHandler - Error handling için hook
 * 
 * Kullanım:
 * const { handleError, showError } = useErrorHandler();
 * 
 * try {
 *   await api.get('/endpoint');
 * } catch (err) {
 *   handleError(err, 'Veri yükleme'); // Otomatik toast gösterir
 * }
 * 
 * veya
 * 
 * showError(err, 'Veri yükleme'); // Sadece toast gösterir
 */
export function useErrorHandler() {
  const toast = useToast();
  
  const handleError = useCallback((error, context = '') => {
    const userMessage = getErrorMessage(error, context);
    
    toast({
      title: "Hata",
      description: userMessage,
      status: "error",
      duration: 5000,
      isClosable: true,
    });
    
    return userMessage;
  }, [toast]);
  
  const showError = useCallback((error, context = '') => {
    return handleError(error, context);
  }, [handleError]);
  
  return {
    handleError,
    showError,
  };
}

export default useErrorHandler;
